<template>
  <div class="tile is-parent is-vertical">
    <div class="tile is-child">
      <div class>
        <div class>
          <section class>
            <section id="entity-content" class>
              <div class="tile is-parent is-vertical">
                <article class="tile is-child notification formbox">
                  <b-tabs>
                    <b-tab-item label="Meu Perfil">
                      <div>
                        <img src="../../assets/images/icon-color/user.svg" class="profile-photo" />

                        <span class="profile-name-a">{{ usuario.name }}</span>
                        <span class="profile-job-a">{{ usuario.cargo }}</span>

                        <div class="div-school">
                          <img src="../../assets/images/icon-color/school-icon.svg" />
                          <span class>{{ usuario.nomeEscola }}</span>
                        </div>
                        <div class="div-member">
                          <img src="../../assets/images/icon-color/id-card.svg" />
                          <span
                            class
                          >Membro desde {{ formatData(usuario.matriculado, 'DD/MM/YYYY') }}</span>
                        </div>
                      </div>
                      <div class="profile-informations">
                        <ul>
                          <li>
                            E-Mail:
                            <span class="profile-infos-span">{{ usuario.email}}</span>
                          </li>
                          <li>
                            Telefone/Celular:
                            <span class="profile-infos-span">{{ usuario.telefone }}</span>
                          </li>
                          <li>
                            Data de Nascimento:
                            <span
                              class="profile-infos-span"
                            >{{ formatData(usuario.nascimento, 'DD/MM/YYYY') }}</span>
                          </li>
                          <li>
                            Senha:
                            <a class="profile-infos-span profile-infos-link">Alterar Senha</a>
                          </li>
                        </ul>
                      </div>
                    </b-tab-item>
                  </b-tabs>
                </article>
              </div>
            </section>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      mostrar: true
    };
  },
  props: ["usuario"]
};
</script>
<style lang="scss" scoped>
@media only screen and (max-width: 720px) {
  .tile.is-parent.is-vertical {
    height: 680px;
    padding-top: 30px;
  }
  .profile-photo {
    margin-left: 0px;
  }
  .profile-name-a {
    margin-left: -150px;
    margin-top: 230px;
  }
  .profile-job-a {
    margin-left: -125px;
    margin-top: 270px;
  }
  .div-school {
    margin-left: 105px;
    margin-top: 60px;
  }
  .div-member {
    margin-left: 45px;
    margin-top: 80px;
  }
  .profile-informations {
    margin-left: 10px;
    bottom: -240px;
    width: 250px;
    line-height: 2rem;
  }
  .profile-informations > ul > li {
    float: left;
  }
  .profile-infos-span{
    margin-left: 3px;
  }
}
</style>